/* ======================================================================
   Beanwatch · Halloween im Hero
   Seit 23.10.2026, Laborseite halloween-labor.html. Auf der Startseite vom
   Do 29.10. bis So 1.11.2026 in Zürcher Zeit, danach wieder der Hero wie
   immer (CI-Guide, Element 114).

   Eingeschaltet wird ohne Schalter (Entscheid Joscha 23.10.2026): Ein
   kleines Skript im <head> der Startseite setzt data-halloween="nacht" an
   <html>, solange das Zürcher Datum im Zeitfenster liegt. halloween.css
   wirkt nur mit diesem Attribut, darum steht der Himmel vom ersten Bild an,
   und BWHalloween.start() tut ohne es nichts. Shopify speichert die Seite
   zwischen, darum entscheidet der Browser und nicht Liquid.

   Der Hero der Startseite bleibt, wie er ist: Fähren, Wellen, Text. Dazu
   kommen zwei Dinge.

   Der Himmel, zwei Fassungen (data-halloween an <html>), entschieden ist
   die Nacht:
     abend  Abendrot. Der Himmel bleibt hell, wird zum Wasser hin warm, die
            Sonne steht tief über dem See und glüht. Beim Scrollen sinkt
            sie hinter die Wellen (die Parallaxe aus animationen.js).
            Schrift und Knöpfe bleiben, wie sie sind.
     nacht  Halloween-Nacht. Dunkelblauer Himmel mit Sternen, statt der
            Sonne der Vollmond. Schrift in Hellorange, Eyebrow und Akzent
            in Cyanblau wie im Prozessweg (Redorange auf Dunkelblau hat nur
            2,8, CI-Guide Kontrast). Die Kopfleiste ist oben hell, bis sie
            klebt.

   Die Kürbisse: fünf leuchtende Kürbisse schwimmen zwischen den Wellen,
   zwei hinten, drei vorne, am Handy drei. Sie liegen eine Ebene vor der
   Fähre ihrer Spur und etwas tiefer, also näher, die Fähren fahren hinter
   ihnen durch. Jeder
   schaukelt wie die Fähren (Heben und Kippen um eine Viertelperiode
   versetzt), treibt ein wenig hin und her, und das Licht darin flackert
   wie eine Kerze.

   Die Gedanken der Fähren und der erste Satz im Laufband (Entscheide
   Joscha 23.10.2026), je nach Sprache der Seite, siehe TEXTE:
     de  KAFFEE «Süsses oder Saures?», RÖSTEREI «Beides. Frisch geröstet
         zu Dir.», Laufband «Halloween-Vibes am Zürichsee»
     en  KAFFEE «Trick or treat?», RÖSTEREI «Treat! Freshly roasted for
         you.», Laufband «Halloween vibes on Lake Zurich»
     fr  KAFFEE «Des bonbons ou un sort ?», RÖSTEREI «Des bonbons !
         Fraîchement torréfiés pour toi.», Laufband «Halloween sur le lac
         de Zurich»
   Eyebrow und H1 bleiben in allen Sprachen.

   bwKuerbis()             ein Kürbis als <svg>, viewBox 120 × 110,
                           Wasserlinie bei y = 86
   BWHalloween.start(o)    stellt den Hero um
                           o.hero      Auswahl des Heros, Vorgabe '#hero'
                           o.himmel    'abend' oder 'nacht', sonst aus
                                       data-halloween an <html>; fehlt
                                       beides, tut start() nichts
                           o.praefix   Pfad zu assets/, auf der Website '/'
                           o.logoHell  Adresse des hellen Logos, im Theme
                                       die Shopify-Adresse
                           o.gedanken  { 'faehre-kaffee': …,
                                       'faehre-roesterei': … } oder false;
                                       ohne Angabe aus TEXTE nach <html lang>
                           o.laufband  erster Satz des Laufbands oder
                                       false; ohne Angabe aus TEXTE

   Braucht faehren.css und halloween.css. Läuft nach animationen.js und
   faehren.js, für die Sterne nach atmosphaere.js. Ohne GSAP, bei
   «Bewegung reduzieren» und bei Tempo «Eingefroren» steht alles still,
   wie gezeichnet.
   ====================================================================== */
(function (global) {
  'use strict';

  const K = '#004B5C';          // Kontur, wie an der Fähre
  const SIGNAL = '#FF4612';     // Kürbis
  const LICHT = '#FFC000';      // Kerzenlicht im Gesicht
  const PAPIER = '#FFF3E8';

  // Jeder Kürbis bekommt eigene Verläufe, Ids sind seitenweit eindeutig.
  let nummer = 0;

  /* --------------------------------------------------------------------
     Der Kürbis
     Fünf Rippen als überlappende Ellipsen, die äussersten zuerst, die
     Mitte obenauf. Kontur 2 wie der Rumpf der Fähre. Das Gesicht ist das
     Licht: Augen, Nase und Mund in Gelb, darüber eine helle Glut, die
     flackert. Dahinter ein weicher Schein. Unter y = 86 liegt der Kürbis
     im Wasser, die Welle davor deckt das ab.
     -------------------------------------------------------------------- */
  function bwKuerbis() {
    const n = ++nummer;
    const schein = 'bw-kuerbis-schein-' + n;
    const gesicht = 'M41 60 L49 47 L56 60 Z M64 60 L71 47 L79 60 Z M56.5 69 L60 63 L63.5 69 Z ' +
      'M37 72 L43 76.5 L48 72.5 L54 78 L60 73 L66 78 L72 72.5 L77 76.5 L83 72 ' +
      'Q79 89 60 90 Q41 89 37 72 Z';
    return `<svg class="kuerbis" viewBox="0 0 120 110" fill="none" aria-hidden="true">
  <defs>
    <radialGradient id="${schein}">
      <stop offset="0" stop-color="${LICHT}" stop-opacity=".55"/>
      <stop offset=".45" stop-color="${LICHT}" stop-opacity=".22"/>
      <stop offset="1" stop-color="${LICHT}" stop-opacity="0"/>
    </radialGradient>
  </defs>
  <g class="kuerbis-schein"><circle class="kuerbis-flackern" cx="60" cy="66" r="58" fill="url(#${schein})"/></g>
  <g class="kuerbis-koerper" stroke="${K}" stroke-width="2" stroke-linejoin="round">
    <path class="kuerbis-stiel" d="M55 37 C55 29 56 23 59.5 18.5 L65.5 20.5 C62.5 24.5 62 30 64.5 37 Z" fill="${K}"/>
    <path d="M64 25 C70 18 78 21 74.5 27.5" stroke-width="1.6" stroke-linecap="round"/>
    <ellipse cx="34" cy="68" rx="23" ry="28" fill="${SIGNAL}"/>
    <ellipse cx="86" cy="68" rx="23" ry="28" fill="${SIGNAL}"/>
    <ellipse cx="46" cy="66" rx="21" ry="31" fill="${SIGNAL}"/>
    <ellipse cx="74" cy="66" rx="21" ry="31" fill="${SIGNAL}"/>
    <ellipse cx="60" cy="65" rx="19" ry="32" fill="${SIGNAL}"/>
    <path d="M18 58 Q19.5 49 25 44" stroke="${PAPIER}" stroke-width="2.2" stroke-linecap="round" opacity=".6"/>
    <path class="kuerbis-gesicht" d="${gesicht}" fill="${LICHT}" stroke-width="1.6"/>
    <path class="kuerbis-glut" d="${gesicht}" fill="${PAPIER}" stroke="none" opacity=".35"/>
  </g>
</svg>`;
  }

  /* --------------------------------------------------------------------
     Wo sie schwimmen
     x ist die Mitte in Anteilen der Hero-Breite, gross die Grösse relativ
     zum vorderen Mass (--kuerbis in halloween.css). Die Lagen sind so
     gewählt, dass beim Laden keiner vor einer Fähre steht: Die KAFFEE
     startet hinten links, die RÖSTEREI vorne rechts. breit: nur ab 700 px,
     am Handy wäre es zu voll.
     -------------------------------------------------------------------- */
  const KUERBISSE = [
    { spur: 'hinten', x: 0.43, gross: 0.6, takt: 2.9 },
    { spur: 'hinten', x: 0.66, gross: 0.52, takt: 3.3, breit: true },
    { spur: 'vorne', x: 0.08, gross: 0.95, takt: 2.4 },
    { spur: 'vorne', x: 0.34, gross: 1.05, takt: 2.7 },
    { spur: 'vorne', x: 0.57, gross: 0.9, takt: 2.5, breit: true }
  ];

  function kuerbisseSetzen(hero) {
    const wellen = hero.querySelector('.hero-wellen');
    if (!wellen) return [];
    // Direkt vor die Welle, die sie bedeckt, also nach der Fähre ihrer
    // Spur: Die Fähren fahren hinter ihnen durch. Lagen sie dahinter,
    // ragten die vorderen über das Deck der RÖSTEREI und sahen aus wie
    // Ladung.
    const vor = {
      hinten: wellen.querySelector('#welle-mitte'),
      vorne: wellen.querySelector('#welle-vorne')
    };
    return KUERBISSE.map((k) => {
      const spur = document.createElement('div');
      spur.className = 'kuerbis-spur kuerbis-spur--' + k.spur + (k.breit ? ' kuerbis-spur--breit' : '');
      spur.style.left = (k.x * 100) + '%';
      spur.style.setProperty('--gross', k.gross);
      spur.innerHTML = bwKuerbis();
      wellen.insertBefore(spur, vor[k.spur] || null);
      return { spur, takt: k.takt };
    });
  }

  /* Schaukeln wie die Fähren (faehren.js), nur kräftiger, ein Kürbis ist
     leicht. Drehpunkt ist die Mitte der Wasserlinie. Dazu ein langsames
     Treiben auf der Spur und das Flackern der Kerze: jedes Mal ein neuer
     Zufallswert (repeatRefresh), kurz und unregelmässig. */
  function beleben(k, i) {
    // Am Handy ausgeblendete (kuerbis-spur--breit) laufen nicht mit.
    if (getComputedStyle(k.spur).display === 'none') return;
    const koerper = k.spur.querySelector('.kuerbis-koerper');
    const versatz = i * 0.37;

    gsap.set(koerper, { svgOrigin: '60 86' });
    gsap.fromTo(koerper, { y: 2 }, {
      y: -4, duration: k.takt, repeat: -1, yoyo: true, ease: 'sine.inOut', delay: versatz
    });
    gsap.fromTo(koerper, { rotation: -5 }, {
      rotation: 5, duration: k.takt, repeat: -1, yoyo: true, ease: 'sine.inOut',
      delay: versatz + k.takt / 2
    });
    gsap.fromTo(k.spur, { x: -7 }, {
      x: 7, duration: gsap.utils.random(6, 9), repeat: -1, yoyo: true, ease: 'sine.inOut',
      delay: -gsap.utils.random(0, 6)
    });
    gsap.to(k.spur.querySelector('.kuerbis-flackern'), {
      opacity: 'random(0.55, 1)', duration: 'random(0.07, 0.24)',
      repeat: -1, repeatRefresh: true, ease: 'none'
    });
    gsap.to(k.spur.querySelector('.kuerbis-glut'), {
      opacity: 'random(0.1, 0.5)', duration: 'random(0.07, 0.24)',
      repeat: -1, repeatRefresh: true, ease: 'none'
    });
  }

  /* --------------------------------------------------------------------
     Der Mond (nur nacht)
     Er ersetzt die Zeichnung der Sonne im selben <svg>. So bleibt alles,
     was animationen.js mit #hero-sonne tut, die Parallaxe beim Verlassen
     des Heros. Die Schleifen der Sonne (Strahlen drehen, Kern atmet)
     werden vorher beendet. Der Hof atmet langsam.
     -------------------------------------------------------------------- */
  function mond(hero, still) {
    const sonne = hero.querySelector('.hero-sonne');
    if (!sonne) return;
    if (global.gsap) gsap.killTweensOf(sonne.querySelectorAll('g, circle'));
    sonne.classList.add('hero-sonne--mond');
    sonne.innerHTML = `
    <defs>
      <radialGradient id="bw-mond-hof">
        <stop offset=".55" stop-color="${PAPIER}" stop-opacity=".22"/>
        <stop offset="1" stop-color="${PAPIER}" stop-opacity="0"/>
      </radialGradient>
    </defs>
    <circle class="mond-hof" cx="100" cy="100" r="96" fill="url(#bw-mond-hof)"/>
    <circle cx="100" cy="100" r="50" fill="${PAPIER}"/>
    <g fill="${K}" opacity=".09">
      <circle cx="84" cy="86" r="11"/><circle cx="116" cy="78" r="6.5"/>
      <circle cx="113" cy="114" r="13"/><circle cx="85" cy="121" r="5.5"/><circle cx="72" cy="104" r="4"/>
    </g>`;
    if (still) return;
    gsap.fromTo(sonne.querySelector('.mond-hof'), { scale: 0.94, opacity: 0.75 }, {
      scale: 1.06, opacity: 1, duration: 4.2, repeat: -1, yoyo: true, ease: 'sine.inOut',
      svgOrigin: '100 100'
    });
  }

  /* Die Sonne im Abendrot (nur abend): Der Kern glüht kräftiger. Die
     Schleife aus animationen.js atmet zwischen 0,16 und 0,28; hier
     zwischen 0,34 und 0,5, sonst stünde der Kern blass vor dem warmen
     Himmel. Die Strahlen drehen weiter. */
  function abendsonne(hero, still) {
    const kern = hero.querySelector('#sonnen-kern');
    if (!kern) return;
    if (global.gsap) gsap.killTweensOf(kern);
    kern.setAttribute('opacity', '.34');
    if (global.gsap) gsap.set(kern, { clearProps: 'opacity,scale,transform' });
    if (still) return;
    gsap.to(kern, {
      scale: 1.07, opacity: 0.5, duration: 3.4,
      repeat: -1, yoyo: true, ease: 'sine.inOut', transformOrigin: '50% 50%'
    });
  }

  /* Sterne (nur nacht) mit sterne() aus atmosphaere.js, im oberen Teil des
     Himmels, kleiner als im Prozessweg. Fehlt atmosphaere.js, bleibt der
     Himmel ohne Sterne. */
  function sterne(hero) {
    const himmel = hero.querySelector('.hero-himmel');
    if (!himmel || !global.BWAtmo) return;
    const feld = document.createElement('div');
    feld.className = 'atmo hero-sterne';
    feld.setAttribute('aria-hidden', 'true');
    feld.dataset.anzahl = window.matchMedia('(max-width:699px)').matches ? '26' : '44';
    feld.dataset.gross = '3.6';
    himmel.after(feld);
    global.BWAtmo.sterne('.hero-sterne');
  }

  /* --------------------------------------------------------------------
     Gedanken der Fähren
     Die Blasen hat faehren.js schon aus data-gedanke gebaut, hier wird nur
     ihr Text getauscht. Sie gehen nacheinander auf, erst die der KAFFEE,
     dann die der RÖSTEREI (blasen() in faehren.js), darum liest es sich
     als Frage und Antwort. Wie hoch die Blasen stehen, misst die Fahrt
     erst beim Refresh nach dem Laden (fahrtEnde() in faehren.js, Refresh
     in basis.js), also schon mit den neuen Texten.

     TEXTE nach den ersten zwei Buchstaben von <html lang> (im Theme
     «de», «en», «fr», im Prototyp «de-CH»). Fehlt eine Sprache, bleiben
     dort Gedanken und Laufband, wie sie sind.
     -------------------------------------------------------------------- */
  const TEXTE = {
    de: {
      gedanken: {
        'faehre-kaffee': 'Süsses oder Saures?',
        'faehre-roesterei': 'Beides. Frisch geröstet zu Dir.'
      },
      laufband: 'Halloween-Vibes am Zürichsee'
    },
    en: {
      gedanken: {
        'faehre-kaffee': 'Trick or treat?',
        'faehre-roesterei': 'Treat! Freshly roasted for you.'
      },
      laufband: 'Halloween vibes on Lake Zurich'
    },
    // Vor «?» und «!» das schmale geschützte Leerzeichen (U+202F), damit
    // das Zeichen nie allein auf die nächste Zeile rutscht.
    fr: {
      gedanken: {
        'faehre-kaffee': 'Des bonbons ou un sort ?',
        'faehre-roesterei': 'Des bonbons ! Fraîchement torréfiés pour toi.'
      },
      laufband: 'Halloween sur le lac de Zurich'
    }
  };

  function gedanken(hero, texte) {
    Object.keys(texte).forEach((id) => {
      const blase = hero.querySelector('#' + id + ' .gedanke-blase');
      if (blase && texte[id]) blase.textContent = texte[id];
    });
  }

  /* Laufband: Getauscht wird der erste Satz. Er steht in beiden Gruppen,
     die zweite ist die Kopie für die nahtlose Schleife (laufband() in
     basis.js läuft um xPercent, die neue Breite stört also nicht). Am
     Handy steht nur er (beanwatch.css, «Laufband am Handy»), dort sehen
     ihn alle. Das erste Laufband der Seite ist das unter dem Hero; im
     Theme liegen beide in eigenen Sektionen, darum nicht über den
     Nachbarn gesucht. */
  function laufband(text) {
    const band = document.querySelector('.laufband');
    if (!band) return;
    band.querySelectorAll('.laufband-gruppe > span:first-child').forEach((satz) => {
      satz.textContent = text;
    });
  }

  /* Die Kopfleiste über dem Nachthimmel (nur nacht): Solange sie nicht
     klebt, steht sie ohne Grund auf Dunkelblau. Dort Schrift und Logo in
     Hellorange (halloween.css), das helle Logo kommt als zweites Bild dazu.
     Klebt sie, ist alles wie immer. */
  function kopfleiste(logoHell) {
    const logo = document.querySelector('.kopf-logo');
    if (!logo || logo.querySelector('.kopf-logo-nacht')) return;
    const hell = document.createElement('img');
    hell.className = 'kopf-logo-nacht';
    hell.src = logoHell;
    hell.alt = '';
    logo.appendChild(hell);
  }

  function start(o) {
    o = o || {};
    const hero = document.querySelector(o.hero || '#hero');
    if (!hero) return;
    // Ausserhalb des Zeitfensters fehlt das Attribut, dann bleibt alles.
    const himmel = o.himmel || document.documentElement.dataset.halloween;
    if (!himmel) return;
    const praefix = o.praefix || '';

    hero.classList.add('hero--halloween');
    document.documentElement.dataset.halloween = himmel;

    const bw = global.BW || {};
    const still = !global.gsap || bw.wenigerBewegung || bw.tempo === 'einfrieren';

    if (himmel === 'nacht') {
      sterne(hero);
      mond(hero, still);
      kopfleiste(o.logoHell || praefix + 'assets/logos/hellorange/quer-einzeilig.svg');
    } else {
      abendsonne(hero, still);
    }

    // Ohne Eintrag in TEXTE bleibt alles, wie es ist.
    const sprache = TEXTE[(document.documentElement.lang || '').slice(0, 2).toLowerCase()] || {};
    const texte = o.gedanken !== undefined ? o.gedanken : sprache.gedanken;
    if (texte) gedanken(hero, texte);
    const satz = o.laufband !== undefined ? o.laufband : sprache.laufband;
    if (satz) laufband(satz);

    const kuerbisse = kuerbisseSetzen(hero);
    if (still) return;
    kuerbisse.forEach(beleben);
    // Auftritt mit den Fähren (faehren.js: 0,7 s Verzögerung), knapp danach.
    gsap.from(kuerbisse.map((k) => k.spur.querySelector('.kuerbis')), {
      autoAlpha: 0, y: 18, duration: 1.2, delay: 1, stagger: 0.12, ease: 'bw-aus'
    });
  }

  global.bwKuerbis = bwKuerbis;
  global.BWHalloween = { start };
})(window);
